import { render, staticRenderFns } from "./tableShow.vue?vue&type=template&id=db301b40"
import script from "./tableShow.vue?vue&type=script&lang=js"
export * from "./tableShow.vue?vue&type=script&lang=js"
import style0 from "./tableShow.vue?vue&type=style&index=0&id=db301b40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports